import React, { useEffect, useRef } from 'react'


const MapListItem = (props) => {

  const inputRef = useRef(null)

  useEffect(() => {
    if (props.activeDetail === props.id) {
      if (inputRef && inputRef.current) {
        // minimal page movement to make the item as visible as possible.
        // anything else was scrolling the map page entirely at smaller heights.
        inputRef.current.scrollIntoView({ block: "nearest", inline: "nearest" })
        // todo deal with pagination.
      }

    }
  }, [props.activeDetail])

  return (
    <>
      <li>
        <a href="#"
          onClick={evt => {
            evt.preventDefault()
            props.setListTarget(props.id)
            props.setDetailsPanelActive(true);
            props.setActiveDetail(props.id);
            props.setMapActive(true)
          }}
          ref={inputRef}
          className={`sopa--map-list-item ${props.activeDetail === props.id ? 'active' : ''} `}>
          {props.icon && <span className="sopa--poi-list_icon"><img src={props.icon} /></span>}
          {props.venue &&
            <span className="sopa--poi-list_venue" dangerouslySetInnerHTML={{ __html: `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 5C0 7.75744 2.24211 10 5.00101 10C7.75789 10 10 7.75744 10 5C10 2.24256 7.75789 1.35181e-06 5.00101 1.35181e-06C2.24211 -0.00200991 0 2.24055 0 5ZM1.61271 5C1.61271 3.13154 3.13091 1.61102 5.00101 1.61102C6.87111 1.61102 8.39131 3.13154 8.39131 5C8.39131 6.87048 6.87111 8.39099 5.00101 8.39099C3.13091 8.38898 1.61271 6.86846 1.61271 5Z" fill="#214A66"/></svg><span>${props.venue}</span>` }} />}
          <span className="sopa--poi-list_title"><h4>{props.title}</h4></span>
          <div className="sopa--poi-list_description" dangerouslySetInnerHTML={{ __html: `${props.description}` }}></div>
          {(props.activeDetail === props.id) && <div className="sopa--map-list-item_active-detail" dangerouslySetInnerHTML={{ __html: `<svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.9987 5.83203C21.6787 5.83203 13.332 14.1787 13.332 24.4987C13.332 38.4987 31.9987 59.1654 31.9987 59.1654C31.9987 59.1654 50.6654 38.4987 50.6654 24.4987C50.6654 14.1787 42.3187 5.83203 31.9987 5.83203ZM31.9987 31.1654C28.3187 31.1654 25.332 28.1787 25.332 24.4987C25.332 20.8187 28.3187 17.832 31.9987 17.832C35.6787 17.832 38.6654 20.8187 38.6654 24.4987C38.6654 28.1787 35.6787 31.1654 31.9987 31.1654Z" fill="#214A66"/></svg> `}}></div>}
        </a>
      </li>
    </>
  )
}

export default MapListItem
